var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlexaTop10K(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.83333,
    stroke: "#5273E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_912:2190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8576 7.71356H6.04804C5.62661 7.71356 5.28613 8.05404 5.28613 8.47547V23.7136C5.28613 24.135 5.62661 24.4755 6.04804 24.4755H25.8576C26.279 24.4755 26.6195 24.135 26.6195 23.7136V8.47547C26.6195 8.05404 26.279 7.71356 25.8576 7.71356ZM24.9052 22.7612H7.00042V9.42785H24.9052V22.7612ZM9.21709 20.8017C9.29089 20.8755 9.41232 20.8755 9.48613 20.8017L13.5933 16.6945L16.3171 19.4207C16.3909 19.4945 16.5123 19.4945 16.5861 19.4207L23.6576 12.3445C23.7314 12.2707 23.7314 12.1493 23.6576 12.0755L22.7814 11.1993C22.7456 11.1638 22.6972 11.1439 22.6468 11.1439C22.5965 11.1439 22.5481 11.1638 22.5123 11.1993L16.4528 17.2612L13.729 14.535C13.6932 14.4995 13.6448 14.4797 13.5945 14.4797C13.5441 14.4797 13.4957 14.4995 13.4599 14.535L8.34328 19.654C8.30783 19.6898 8.28794 19.7382 8.28794 19.7886C8.28794 19.8389 8.30783 19.8873 8.34328 19.9231L9.21709 20.8017Z",
    fill: "#5273E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_912:2190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 21.3333,
    fill: "none",
    transform: "translate(5.33301 5.33333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlexaTop10K);
export default __webpack_public_path__ + "static/media/alexa_top10k.d1906bc23f54d084588a69896fde5f2b.svg";
export { ForwardRef as ReactComponent };